import React from 'react';

const PermissionsContext = React.createContext({});
const { Provider: PermissionsContextProvider, Consumer: PermissionsContextConsumer } = PermissionsContext;

export default PermissionsContext;
export { PermissionsContextProvider, PermissionsContextConsumer };
